export default function generateEntityName(entity, pieceOfName) {
  return `${pieceOfName} ${entity.length + 1}`;
}
